"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
const TabNav = _ref => {
  let {
    active,
    disable,
    className,
    children,
    onClick
  } = _ref;
  const onTabClick = _react.default.useCallback(() => {
    if (disable === true || !(0, _ark.isFunction)(onClick)) return;
    onClick();
  }, [onClick, disable]);
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: (0, _arkReact.concatClassName)('tabNavItem', className, active ? 'tabNavItem-active' : null, disable ? 'tabNavItem-disable' : null),
    onClick: onTabClick
  }, children);
};
process.env.NODE_ENV !== "production" ? TabNav.propTypes = {
  active: _propTypes.default.bool,
  disable: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func
} : void 0;
TabNav.defaultProps = {
  active: false,
  disable: false,
  className: undefined,
  children: undefined,
  onClick: undefined
};
var _default = exports.default = TabNav;